const REMINDER_EVENT_DURATION_MS = 15 * 60 * 1000;

function toGoogleCalendarDate (date) {
    return date.toISOString().replace(/[-:]|\.\d{3}/g, '');
}

export function buildGoogleCalendarEventUrl ({ title, details, start, end }) {
    const params = new URLSearchParams({
        action: 'TEMPLATE',
        text: title,
        dates: `${toGoogleCalendarDate(start)}/${toGoogleCalendarDate(end)}`,
        details,
    });

    return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function buildGuestAccessReminderUrl ({ title, details, expiresAt }) {
    const start = new Date(expiresAt);
    const end = new Date(expiresAt + REMINDER_EVENT_DURATION_MS);

    return buildGoogleCalendarEventUrl({ title, details, start, end });
}
